module.exports = __webpack_public_path__ + "media/images/flags/sl-04b633dea7554ee5326da5a43f755724.svg";